const lockScroll = () => {
  const body = document.querySelector('body');
  body.style.overflow = 'hidden';
};

const unlockScroll = () => {
  const body = document.querySelector('body');
  body.style.overflow = 'auto';
};

// Coordinate aria-hidden on <main> across overlapping overlays (cart drawer,
// mobile menu, mega menu). <main> is hidden from assistive tech while any
// overlay is open and only re-exposed once the last one closes. Keyed by owner
// so repeated opens of the same overlay (e.g. hovering between mega-menu links)
// stay balanced with a single close.
const backgroundHiddenBy = new Set();

// <main> is rendered unconditionally in the layout, so a miss signals a markup
// regression — warn loudly rather than silently dropping background hiding.
const getMain = () => {
  const main = document.querySelector('main');
  if (!main) {
    console.warn(
      '[overlay] <main> not found; skipping background aria-hidden toggle.'
    );
  }
  return main;
};

const hideBackground = (owner) => {
  const main = getMain();
  if (!main) return;
  backgroundHiddenBy.add(owner);
  main.setAttribute('aria-hidden', 'true');
};

const showBackground = (owner) => {
  const main = getMain();
  if (!main) return;
  backgroundHiddenBy.delete(owner);
  if (backgroundHiddenBy.size === 0) main.removeAttribute('aria-hidden');
};

// Cart drawer open/close race coordination. The drawer's open state is a single
// attribute (aria-expanded), so an async "open the cart" action (e.g. add-to-cart,
// the configurators, getCart) whose request resolves after the user manually closed
// the drawer would otherwise reopen it — leaving the full-screen overlay trapping
// every click. The drawer stamps a close generation on each user close; callers
// snapshot it before their await and only reopen if it is unchanged.

// #cart-drawer is intentionally absent on some templates (the /cart page gates it in
// theme.liquid, the password layout omits it), so a missing element is a legitimate
// no-op, not an error — these helpers fail open silently.
const cartDrawerCloseGeneration = () =>
  document.querySelector('#cart-drawer')?.dataset.closeGeneration;

const markCartDrawerClosed = () => {
  const drawer = document.querySelector('#cart-drawer');
  if (!drawer) return;
  drawer.dataset.closeGeneration = String(
    (Number(drawer.dataset.closeGeneration) || 0) + 1
  );
};

const requestCartDrawerOpen = (closeGenerationBefore) => {
  // Skip when the user dismissed the drawer while the async work was in flight.
  if (cartDrawerCloseGeneration() !== closeGenerationBefore) return;
  document.dispatchEvent(new CustomEvent('cart:open'));
};

// Variant field guard: treats null, empty string and a zero-ish value as absent.
// Variant JSON from `variant-select.liquid` stringifies everything, so '0' has to
// count as missing alongside 0.
const hasValue = (value) => {
  return value != null && value !== '' && value !== '0' && value !== 0;
};

// A variant is on sale when it has a compare-at price that differs from its price.
// Shared by the buy box (compare price + Sale splash) and the sticky add-to-cart
// bar so the rule lives in one place.
const isOnSale = (variant) => {
  return (
    hasValue(variant?.compare_at_price) &&
    variant.compare_at_price !== variant?.price
  );
};

export {
  lockScroll,
  unlockScroll,
  hideBackground,
  showBackground,
  cartDrawerCloseGeneration,
  markCartDrawerClosed,
  requestCartDrawerOpen,
  hasValue,
  isOnSale,
};
